export { default } from './Checkbox';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Checkbox/index.js
// module id = 401
// module chunks = 2